import { render, staticRenderFns } from "./_totalPlayedMiniGameDetail.vue?vue&type=template&id=9cc73afa&lang=pug"
import script from "./_totalPlayedMiniGameDetail.vue?vue&type=script&lang=js"
export * from "./_totalPlayedMiniGameDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports